module.exports = __webpack_public_path__ + "static/media/model-l200-91.53633d5f.webp";